//@flow
export const FETCH_USER_CHECKOUTS_REQUEST = 'FETCH_USER_CHECKOUTS_REQUEST'
export const FETCH_USER_CHECKOUTS_SUCCESS = 'FETCH_USER_CHECKOUTS_SUCCESS'
export const FETCH_USER_CHECKOUTS_FAILED = 'FETCH_USER_CHECKOUTS_FAILED'

export const FETCH_PENDING_CHECKOUTS_REQUEST = 'FETCH_PENDING_CHECKOUTS_REQUEST'
export const FETCH_PENDING_CHECKOUTS_SUCCESS = 'FETCH_PENDING_CHECKOUTS_SUCCESS'
export const FETCH_PENDING_CHECKOUTS_FAILED = 'FETCH_PENDING_CHECKOUTS_FAILED'

export const STORE_CHECKOUTS = 'STORE_CHECKOUTS'

export const SAVE_CHECKOUT_REQUEST = 'SAVE_CHECKOUT_REQUEST'
export const SAVE_CHECKOUT_SUCCESS = 'SAVE_CHECKOUT_SUCCESS'
export const SAVE_CHECKOUT_FAILED = 'SAVE_CHECKOUT_FAILED'

export const CLEAN_CHECKOUTS = 'CLEAN_CHECKOUTS'
export const CHECKOUT_CREATED = 'CHECKOUT_CREATED'
export const CHECKOUT_PATCHED = 'CHECKOUT_PATCHED'
export const USER_CHECKOUTS_SET = 'userCheckouts'

export const FETCH_USER_CHECKOUTS_RESOURCE = 'user:checkouts'
export const FETCH_PENDING_CHECKOUTS_RESOURCE = 'pending:checkouts'

export const createCheckoutSaveResource = (id: string) => `checkout:${id}:save`

// mimic backend/models/checkout state and shipping options
export const CHECKOUT_STATE = {
  // Checkout has not been paid yet
  PENDING: 'pending',
  // Checkout is paid, but shipping details not fulfilled
  PAYMENT_OK: 'payment_ok',
  // Checkout payment failed, not fulfilled
  PAYMENT_FAIL: 'payment_fail',
  // Checkout expired (paid or not)
  EXPIRED: 'expired',
  // Checkout is paid, user selected details
  COMPLETED: 'completed'
}

export const CHECKOUT_SHIPPING_OPTION = {
  PICK_UP_CHARITY: 'pickUpCharity',
  PICK_UP_EVENT: 'pickUpEvent',
  HOME_DELIVERY: 'homeDelivery'
}

export const CHECKOUT_ITEM_STATE = {
  // charge not attempted, default state
  PENDING: 'pending',
  // last charge attempt failed
  ERROR: 'error',
  // charge succeeded
  PAID: 'paid',
  // no more charge attempts (to be defined when/how to set this state)
  EXPIRED: 'expired'
}

export const CLEAN_CHECKOUT_ITEMS = 'CLEAN_CHECKOUT_ITEMS'
export const STORE_CHECKOUT_ITEMS = 'STORE_CHECKOUT_ITEMS'
export const CHECKOUT_ITEM_CREATED = 'CHECKOUT_ITEM_CREATED'
export const CHECKOUT_ITEM_PATCHED = 'CHECKOUT_ITEM_PATCHED'
export const USER_CHECKOUT_ITEMS_SET = 'userCheckoutItems'

export const FETCH_CHECKOUT_WITH_AUCTION_RESOURCE = 'checkoutWithAuction'
export const FETCH_CHECKOUT_WITH_AUCTION_REQUEST =
  'FETCH_CHECKOUT_WITH_AUCTION_REQUEST'
export const FETCH_CHECKOUT_WITH_AUCTION_SUCCESS =
  'FETCH_CHECKOUT_WITH_AUCTION_SUCCESS'
export const FETCH_CHECKOUT_WITH_AUCTION_FAILED =
  'FETCH_CHECKOUT_WITH_AUCTION_FAILED'
export const STORE_CHECKOUT_WITH_AUCTION = 'STORE_CHECKOUT_WITH_AUCTION'



// WEBPACK FOOTER //
// ./src/services/checkout/constants.js